export default "__VITE_ASSET__CdRADaBv__"